import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { ApplicationUser } from './ApplicationUser';

export class User extends ApplicationUser {
    _originalTypeClassName = "MidApp.BO.User";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
User.translate = translateService;
}
super();
this.Tickets = [];
this.Id = null;
this.Phone = null;
this.DisableUser = false;
this.LastToken = null;
this.avatarName = null;
this.themeName = null;
this.Gender = null;
this.GenderString = null;
this.City = null;
this.userLanguage = null;
this.userExpiresIn = null;
this.LastCode = null;
this.Company = null;
this.KnowledgeBasedManagement = false;
this._key = this.UserName = ""; 
}

static translate: TranslateService;
_key: any;
Id:any;
Phone:any;
DisableUser:any;
LastToken:any;
avatarName:any;
themeName:any;
Gender:any;
GenderString:any;
City:any;
userLanguage:any;
userExpiresIn:any;
LastCode:any;
Company:any;
KnowledgeBasedManagement:any;
Tickets:any;
static setTickets = ($this, items) => {
                if (items == null) items = [];
                if ($this.Tickets == null) $this.Tickets = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Tickets.length > 0) {
                    Domain.User.removeTickets($this, $this.Tickets[0]);
                }

                Domain.User.addManyTickets($this, copyItems);
            }
static addManyTickets = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.User.addTickets($this, items[i]);
                }
            }
static addTickets = ($this, item) => {
                if ($this.Tickets == null) $this.Tickets = [];
                if (item == null || $this.Tickets.indexOf(item) > -1) return;
                $this.Tickets.push(item);
}
static addRangeTickets = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.User.addTickets($this, item));
            }
static removeTickets = ($this, item) => {
                if ($this == null || $this.Tickets == null || $this.Tickets.indexOf(item) === -1) return;
                var _index = $this.Tickets.indexOf(item);
                $this.Tickets.splice(_index, 1);
}
static clearTickets = ($this) => { $this.Tickets = null; }

static FindFirstName($this: any): any{let firstName = "";
for (var index = 0; CLMS.Framework.Number.LessThan(() => index, () => $this.Name.length); index = Joove.Common.safeNumber(index) + Joove.Common.safeNumber(1)) {
let character = $this?.Name[index];if (character == ' ') {break;}firstName = firstName + character;}

return firstName;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UserName == null || $this.UserName == "";
            }


}